import React from 'react';
import { Spinner, makeStyles, tokens, shorthands } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    ...shorthands.padding(tokens.spacingVerticalL),
  },
});

interface LoadingProps {
  label?: string;
}

export const Loading: React.FC<LoadingProps> = ({ label = 'Loading...' }) => {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <Spinner label={label} />
    </div>
  );
};
